export default __webpack_public_path__ + "static/media/572.a9f7f961.gif";